<template>
  <div class="add-material-modal">
    <q-form @submit="onSubmit" class="modal-form">
      <div class="modal-content">
        <div class="form-field">
          <CustomInput label="Наименование материала" placeholder="Введите..." :value="formData.material_name"
            @change_input="(value) => onChange('material_name', value)" required :showClearIcon="false" />
        </div>

        <div class="form-field">
          <CustomSelect :options="materialTypes" label="Тип материала" optionValueKey="material_type_id"
            optionLabelKey="material_type_name" placeholder="Не выбрано" :value="formData.material_type_id || ''"
            @change="(value, row) => onChange('material_type_id', value, row)" required />
        </div>

        <div class="form-field">
          <q-input
            v-model="formData.nomenklatura_name"
            outlined
            dense
            readonly
            placeholder="Выберите номенклатуру"
            label="Номенклатура 1С"
            class="guid-input"
          >
            <template v-slot:prepend>
              <q-btn
                icon="list"
                flat
                dense
                round
                @click="openNomenklaturaSelector"
              >
                <q-tooltip>Выбрать номенклатуру</q-tooltip>
              </q-btn>
            </template>
            <template v-slot:append>
              <q-btn
                v-if="formData.guid"
                icon="clear"
                flat
                dense
                round
                @click="clearGuid"
              >
                <q-tooltip>Очистить выбор</q-tooltip>
              </q-btn>
            </template>
          </q-input>
          <div v-if="formData.guid" class="guid-display">GUID: {{ formData.guid }}</div>
        </div>

        <div class="form-field">
          <CustomSelect 
            :options="unitOptions" 
            label="Единица измерения расхода" 
            option-label-key="unit_name"
            option-value-key="unit_id" 
            @change="(value, row) => onChange('consume_unit_id', value, row)"
            :value="formData.consume_unit_id" 
            placeholder="Не выбрано" 
            required 
          />
        </div>

        <div class="form-field">
          <CustomSelect 
            :options="requiredTypes" 
            label="Тип потребности материала" 
            option-label-key="required_type_name"
            option-value-key="required_type_id" 
            @change="(value) => onChange('required_type_id', value)"
            :value="formData.required_type_id" 
            placeholder="Не выбрано" 
          />
        </div>
      </div>
      <CustomModalFooter :btn-loading="loading" />
    </q-form>

    <!-- Диалог выбора номенклатуры -->
    <q-dialog v-model="nomenklaturaSelectorDialog.show" persistent>
      <q-card style="min-width: 800px; max-width: 1000px; height: 80vh; display: flex; flex-direction: column;">
        <q-card-section class="row items-center q-pb-none" style="flex-shrink: 0;">
          <div class="text-h6">Выбор номенклатуры из 1С</div>
          <q-space />
          <q-btn icon="close" flat round dense @click="nomenklaturaSelectorDialog.show = false" />
        </q-card-section>

        <q-card-section style="flex: 1; overflow: hidden; display: flex; flex-direction: column; padding: 0;">
          <SelectNomenklatura
            :data="{
              onSelect: selectNomenklatura
            }"
            :closeModal="closeNomenklaturaDialog"
          />
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomButton from "@/components/common/CustomButton";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import SelectNomenklatura from "@/components/modal/modals/select-nomenklatura/index.vue";
import instance from "@/services/api";
import { getUnitsList, getMaterialTypesFilter } from "@/views/Materials/services";

export default {
  name: "add-material",
  components: {
    CustomInput,
    CustomSelect,
    CustomButton,
    CustomModalFooter,
    SelectNomenklatura
  },
  props: ["data"],
  data() {
    return {
      loading: false,
      formData: {
        material_id: this.data?.body?.material_id || "",
        material_name: this.data?.body?.material_name || "",
        material_type_id: this.data?.body?.material_type_id || "",
        guid: this.data?.body?.guid || "",
        nomenklatura_name: this.data?.body?.ssylka__view || "",
        consume_unit_id: "",
        required_type_id: this.data?.body?.required_type_id || "",
      },
      materialTypes: [],
      unitOptions: [],
      requiredTypes: [],
      nomenklaturaSelectorDialog: {
        show: false
      },
    };
  },
  methods: {
    async getUnitsList() {
      const res = await getUnitsList();
      if (!res) return;
      this.unitOptions = res;

      if (this.data?.body) {
        this.initializeEditData();
      }
    },
    async getMaterialList() {
      const res = await getMaterialTypesFilter();
      if (!res) return;
      this.materialTypes = res;
    },
    async getRequiredTypes() {
      try {
        const { data } = await instance().get("/required/required-type-material/");
        this.requiredTypes = data?.data || [];
      } catch (e) {
        console.error(e);
      }
    },
    findUnitIdByName(unitName) {
      if (!unitName || !this.unitOptions.length) return "";
      const unit = this.unitOptions.find(u => u.unit_name === unitName);
      return unit ? unit.unit_id : "";
    },
    initializeEditData() {
      const body = this.data.body;

      if (body.consume_unit) {
        this.formData.consume_unit_id = this.findUnitIdByName(body.consume_unit);
      }
    },
    onChange(key, value, row) {
      this.formData[key] = value;

      if (key === 'material_id' && row) {
        this.formData.material_name = row.material_name || '';
      }
    },
    onCancel() {
      if (this.data?.onCancel) {
        this.data.onCancel();
      }
    },
    buildPayload() {
      const payload = {
        material_name: this.formData.material_name,
        material_type_id: this.formData.material_type_id,
        consume_unit_id: this.formData.consume_unit_id,
        guid: this.formData.guid,
        required_type_id: this.formData.required_type_id || null,
      };

      if (this.formData.material_id) {
        payload.material_id = this.formData.material_id;
      }

      return payload;
    },
    async onSubmit() {
      this.loading = true;
      const payload = this.buildPayload();
      if (this.data?.onSubmit) {
        await this.data.onSubmit(payload);
      }
      this.loading = false;
    },
    openNomenklaturaSelector() {
      this.nomenklaturaSelectorDialog.show = true;
    },
    closeNomenklaturaDialog() {
      this.nomenklaturaSelectorDialog.show = false;
    },
    selectNomenklatura(item) {
      if (item && item.ssylka__id) {
        this.formData.guid = item.ssylka__id;
        this.formData.nomenklatura_name = item.naimenovanie || "";
      }
      this.closeNomenklaturaDialog();
    },
    clearGuid() {
      this.formData.guid = "";
      this.formData.nomenklatura_name = "";
    },
  },
  mounted() {
    this.getUnitsList();
    this.getMaterialList();
    this.getRequiredTypes();
  },
};
</script>

<style scoped lang="scss">
.add-material-modal {
  width: 100%;
}

.modal-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-field {
  width: 100%;
}

.guid-display {
  font-family: 'Courier New', monospace;
  font-size: 11px;
  color: #1976d2;
  margin-top: 4px;
  padding-left: 4px;
}

@media (max-width: 900px) {
  .add-material-modal {
    max-width: 95vw !important;
  }
}
</style>